<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.2816 2H0.969232C0.43421 2 0.000488281 2.64863 0.000488281 3.44876C0.000488281 4.24889 0.43421 4.89752 0.969232 4.89752H22.2816C22.8166 4.89752 23.2503 4.24889 23.2503 3.44876C23.2503 2.64863 22.8166 2 22.2816 2Z"
      fill="currentColor"
    />
    <path
      d="M18.4061 10.5513H0.968743C0.433721 10.5513 0 11.1999 0 12C0 12.8002 0.433721 13.4488 0.968743 13.4488H18.4061C18.9411 13.4488 19.3749 12.8002 19.3749 12C19.3749 11.1999 18.9411 10.5513 18.4061 10.5513Z"
      fill="currentColor"
    />
    <path
      d="M22.2811 19.1025H0.968744C0.433721 19.1025 0 19.7512 0 20.5513C0 21.3514 0.433721 22.0001 0.968744 22.0001H22.2811C22.8161 22.0001 23.2498 21.3514 23.2498 20.5513C23.2498 19.7512 22.8161 19.1025 22.2811 19.1025Z"
      fill="currentColor"
    />
  </svg>
</template>
